import YandexMap from 'components/yandex-map';

/**
 * Карта в блоке контакты
 */
const contactsMap = document.querySelector('.j-contacts-map');

if (contactsMap) {
    const ymaps = window.ymaps;

    if (ymaps) {
        ymaps.ready(() => {
            const yandexMap = new YandexMap(ymaps);

            yandexMap.init({
                wrapper                : contactsMap,
                cluster                : true,
                fullScreenControl      : true,
                customFullScreenControl: true,
                customZoomControl      : true
            });
        });
    }
}
